<template>
  <div class="shared-link-main">
    <el-container class="shared-link-container">
      <el-header
        :bordered="false"
        class="shared-link-header">

        <span
          class="shared-link-wrh-logo"
          v-if="isWrhAppType"
        />

        <span
          class="shared-link-wre-logo"
          v-if="isWreAppType"
        />

        <!--        <span-->
        <!--          class="shared-link-unknown-logo"-->
        <!--          v-if="isUnknownAppType"-->
        <!--        />-->

      </el-header>
      <el-main class="shared-link-main">

        <shared-link-password-dialog-box
          v-if="isPasswordViewVisible"
        />

        <shared-link-restore-not-found
          v-if="isLinkNotFoundViewVisible"
        />

        <shared-link-restore-file
          v-if="isRestoreFileViewVisible"
          @restore="download"
        />

        <shared-link-restore-folder
          v-if="isRestoreFolderViewVisible"
          @restore="download"
        />

        <router-view/>
      </el-main>
      <el-footer
        class="shared-link-footer"
        v-if="!isLinkNotFoundViewVisible">
        <view-footer-home
          v-if="isWrhAppType"
        />
        <view-footer-enterprise
          v-if="isWreAppType"
        />
      </el-footer>
    </el-container>

  </div>
</template>

<style lang="scss" scoped>

  .shared-link-wrh-logo {
    display: inline-block;
    text-align: left;
    background: url('../assets/logo/wrh-logo-dark.svg') no-repeat;
    width: 256px;
    height: 64px;
    margin: 16px;
  }

  .shared-link-wre-logo {
    display: inline-block;
    text-align: left;
    background: url('../assets/logo/wre-logo-dark.svg') no-repeat;
    width: 256px;
    height: 64px;
    margin: 16px;
  }

  .shared-link-unknown-logo {
    display: inline-block;
    text-align: left;
    background: url('../assets/logo/acronis-dark.svg') no-repeat;
    width: 122px;
    height: 64px;
    margin: 16px;
  }

  .shared-link-container {
    height: 100vh;
  }

  .shared-link-header {
    height: 64px;
    background-color: $av-fixed-white;
  }

  .shared-link-footer {
    z-index: 5000;
    height: 64px;
    background-color: $av-brand-lightest;
  }
</style>

<script>
import { createNamespacedHelpers } from 'vuex';

import SharedLinkPasswordDialogBox from './SharedLinkPasswordDialogBox';
import SharedLinkRestoreFile from './SharedLinkRestoreFile';
import SharedLinkRestoreFolder from './SharedLinkRestoreFolder';
import SharedLinkRestoreNotFound from './SharedLinkRestoreNotFound';
import ViewFooterHome from './ViewFooterHome';
import ViewFooterEnterprise from './ViewFooterEnterprise';

import { PENDING_STATUS } from '../store/action-status';

import {
  FETCH_LINK_DETAILS,
  SETUP_LINK_CIPHER,
  SHOW_SHARED_VIEW,
  UPDATE_APP_TYPE
} from '../store/action-types';

import {
  RESTORE_SHARED_FILE,
  RESTORE_SHARED_FOLDER,
  SHARED_LINK_NOT_FOUND,
  SHARED_LINK_PASSWORD
} from '../store/active-shared-view';

import { UNKNOWN, WRE, WRH, WR } from '../store/app-type';

const { mapGetters, mapActions } = createNamespacedHelpers('shared-link');

export default {
  name: 'SharedLinkMain',
  components: {
    SharedLinkPasswordDialogBox,
    SharedLinkRestoreFile,
    SharedLinkRestoreFolder,
    SharedLinkRestoreNotFound,
    ViewFooterHome,
    ViewFooterEnterprise
  },
  data: function () {
    return {
      fullScreenLoader: ''
    };
  },
  computed: {
    ...mapGetters([
      'getLinkCipher',
      'getLinkPassword',
      'getActiveSharedView',
      'getAppType',
      'getLinkDetails',
      'getFetchLinkDetailsStatus'
    ]),
    isPasswordViewVisible() {
      return this.getActiveSharedView === SHARED_LINK_PASSWORD;
    },
    isLinkNotFoundViewVisible() {
      return this.getActiveSharedView === SHARED_LINK_NOT_FOUND;
    },
    isRestoreFileViewVisible() {
      return this.getActiveSharedView === RESTORE_SHARED_FILE;
    },
    isRestoreFolderViewVisible() {
      return this.getActiveSharedView === RESTORE_SHARED_FOLDER;
    },
    isWrhAppType() {
      return this.getAppType === WRH;
    },
    isWreAppType() {
      return this.getAppType === WRE;
    },
    isWrAppType() {
      return this.getAppType === WR;
    },
    isUnknownAppType() {
      return this.getAppType === UNKNOWN;
    }
  },
  watch: {
    getFetchLinkDetailsStatus(status) {
      if (status === PENDING_STATUS) {
        this.showLoading();
      } else {
        this.hideLoading();
      }
    }
  },
  methods: {
    ...mapActions({
      setupLinkCipher: SETUP_LINK_CIPHER,
      showSharedView: SHOW_SHARED_VIEW,
      updateAppType: UPDATE_APP_TYPE,
      fetchLinkDetails: FETCH_LINK_DETAILS
    }),
    // path: files/folders path or path array. (The folder paths should ends '/')
    // set 'path' to empty if need to restore link's default path
    download(path) {
      const linkCipher = this.getLinkCipher;
      const password = this.getLinkPassword;
      const baseURL = `${window.location.origin + window.location.pathname}ui`;
      const element = document.createElement('a');

      let pathArgs = '';
      if (path !== undefined) {
        if (Array.isArray(path)) {
          path.forEach(function (item) {
            pathArgs += `&path=${encodeURIComponent(item)}`;
          });
        } else if (path !== '') {
          pathArgs = `&path=${encodeURIComponent(path)}`;
        }
      }

      let passwordArg = '';
      if (password !== undefined && password !== '') {
        passwordArg = `&key=${encodeURIComponent(password)}`;
      }

      element.setAttribute('href', `${baseURL
      }/linkRestore?linkCipher=${encodeURIComponent(linkCipher)}${passwordArg}${pathArgs}`);
      element.setAttribute('download', '');
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    init() {
      this.fetchLinkDetails({
        linkCipher: this.$route.params.cipher
      });
    },
    showLoading() {
      this.fullScreenLoader = this.$loading({
        background: 'fixed-modal',
        color: 'fixed-white',
        size: '48',
        lock: true
      });
    },
    hideLoading() {
      if (this.fullScreenLoader !== '') {
        this.fullScreenLoader.close();
      }
    }
  },
  async created() {
    await this.init();
  }
};
</script>
